import { useState, useEffect } from "react";
import { useZoomTransition } from "../../hooks/useZoomTransition";
import {
  clearAuthEntranceTransition,
  readAuthEntranceTransition,
} from "./authEntrance";
import { MARKETING_HOME } from "./marketingHome";

type UseAuthPageChromeOptions = {
  /** Login/register: read + strip `?vt=` entrance handoff */
  entrance?: boolean;
};

/**
 * Shared auth page chrome: marketing-home zoom, entrance variant, class helpers.
 */
export function useAuthPageChrome(options: UseAuthPageChromeOptions = {}) {
  const [transition] = useState(() =>
    options.entrance ? readAuthEntranceTransition() : "",
  );
  const { triggerZoomOut, zoom, zoomProps } = useZoomTransition(MARKETING_HOME);

  useEffect(() => {
    if (transition) clearAuthEntranceTransition();
  }, [transition]);

  const anim = "auth-animated";
  const variant = transition === "white" ? "auth-from-white" : "";

  const pageClassName = (
    ...parts: Array<string | false | null | undefined>
  ) =>
    ["auth-page", ...parts, anim, variant, zoom ? "auth-zoom-out" : ""]
      .filter(Boolean)
      .join(" ");

  return {
    triggerZoomOut,
    zoom,
    zoomProps,
    anim,
    variant,
    pageClassName,
  };
}
